const state = {
    nav:'',
  }
  
  const mutations = {
    setNav(state,nav){
      state.nav=nav;
    }
  }
  
  const actions = {
    setNav({commit},nav){
      commit('setNav',nav);
    }
  }
  
  export default {
    namespaced: true,
    state,
    mutations,
    actions
  }
  